import { LatencySource } from '../../../services/networkLatencyObserver';
import {
  DEGRADED_EFFECTIVE_TYPES,
  DEGRADED_TIMEOUT_COUNT_THRESHOLD,
  MAX_ACCEPTABLE_AVG_LATENCY_MS,
  MAX_ACCEPTABLE_NETWORK_LATENCY_MS,
  MAX_ACCEPTABLE_NETWORK_LATENCY_MS_BY_SOURCE,
  MAX_ACCEPTABLE_RTT_MS,
  MIN_ACCEPTABLE_DOWNLINK_MBPS,
} from '../NetworkStatusProvider.constants';
import {
  NETWORK_TRIGGER,
  NetworkSignals,
  NetworkTrigger,
} from '../NetworkStatusProvider.types';

const resolveNetworkLatencyThresholdMs = (source?: LatencySource): number => {
  if (
    source !== undefined &&
    MAX_ACCEPTABLE_NETWORK_LATENCY_MS_BY_SOURCE[source] !== undefined
  ) {
    return MAX_ACCEPTABLE_NETWORK_LATENCY_MS_BY_SOURCE[source] as number;
  }

  return MAX_ACCEPTABLE_NETWORK_LATENCY_MS;
};

export const computeDegradedCandidate = (
  signals: NetworkSignals,
): NetworkTrigger | undefined => {
  const {
    effectiveType,
    rtt,
    downlink,
    measuredDownlinkMbps,
    rollingAverageLatencyMs,
    hasNetworkMeasurement,
    latencySource,
    timeoutCountInWindow,
  } = signals;

  const maxAcceptableLatencyMs = hasNetworkMeasurement
    ? resolveNetworkLatencyThresholdMs(latencySource)
    : MAX_ACCEPTABLE_AVG_LATENCY_MS;

  const effectiveDownlinkMbps = measuredDownlinkMbps ?? downlink;

  const hasDegradedEffectiveType =
    effectiveType !== undefined &&
    (DEGRADED_EFFECTIVE_TYPES as readonly string[]).includes(effectiveType);

  if (hasDegradedEffectiveType) {
    return NETWORK_TRIGGER.EFFECTIVE_TYPE;
  }

  if (rtt !== undefined && rtt > MAX_ACCEPTABLE_RTT_MS) {
    return NETWORK_TRIGGER.RTT;
  }

  if (
    effectiveDownlinkMbps !== undefined &&
    effectiveDownlinkMbps < MIN_ACCEPTABLE_DOWNLINK_MBPS
  ) {
    return NETWORK_TRIGGER.DOWNLINK;
  }

  if (
    rollingAverageLatencyMs !== undefined &&
    rollingAverageLatencyMs > maxAcceptableLatencyMs
  ) {
    return NETWORK_TRIGGER.LATENCY;
  }

  if (timeoutCountInWindow >= DEGRADED_TIMEOUT_COUNT_THRESHOLD) {
    return NETWORK_TRIGGER.TIMEOUTS;
  }

  return undefined;
};
